import React from 'react'
import HOME_TOPIC_TWO from "../../global/assets/png/Topic-Two.png"
import { isMobile } from '../../global/ScreenSizeHelper';

const TopicTwo = () => {

    if (isMobile) {
        return (
            <>
                Mobile Topic Two
            </>
        )

    }


    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'row',
            // backgroundColor: '#f6f6f6',
            width: '100%',
            height: '600px',
        }}>

            <div style={{
                width: '600px',
                marginLeft: '2px',
                // border: '1px solid black', 
                padding: '80px 0px 0px 20px'
            }}>
                <img alt="" src={HOME_TOPIC_TWO} width={500} style={{ marginBottom: '33px' }} ></img>
            </div>
            <div style={{
                width: '600px',
                padding: '110px 0px 0px 20px',
                flexWrap: 'wrap',
                // border: '1px solid red' 
            }}>
                <div style={{
                    color: '#1B1642',
                    fontSize: '50px',
                    fontFamily: 'Inter Medium',
                    lineHeight: '50px',
                    flexWrap: 'wrap',
                    marginTop: '30px'


                }}> <a style={{
                    color: '#1B1642',
                    fontFamily: 'Inter Medium',
                    fontSize: '45px',
                    padding: '3px 6px 3px 6px',
                    height: '100px',
                    border: '1px solid #06763f',
                    borderRadius: '10px',
                    backgroundColor: '#dff5cf',

                }}>Free</a> Complementary meal with every order

                </div>
                <div style={{
                    fontFamily: 'Inter Regular', color: '#1B1642',
                    fontSize: '25px', marginTop: '20px'
                }}>A conversation with Libor Michalek, President of Affirm about how they pioneered a new type of lending.</div>
            </div>
        </div>
    )
}

export default TopicTwo